import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { DynamicCampaignBuilder } from '../components/DynamicCampaignBuilder';

/** Route entry point: turns the URL into builder props. */
export const DynamicCampaignV2Page: React.FC = () => {
  const { configIdOrType, campaignId } = useParams<{ configIdOrType: string; campaignId?: string }>();
  const [searchParams] = useSearchParams();
  const configIdToUse = configIdOrType || searchParams.get('configId');
  // Presets are launched via ?presetId with no configId in the URL — the config is resolved
  // from the preset itself.
  const presetId = searchParams.get('presetId');
  if (!configIdToUse && !presetId) return <div>Invalid config ID or type</div>;
  return (
    <DynamicCampaignBuilder
      configIdOrType={configIdToUse ?? ''}
      campaignId={campaignId}
      presetId={presetId ?? undefined}
      // Remounting on a URL change is what resets the form; without it, navigating
      // straight from one campaign to another keeps the first one's field values.
      key={`${configIdToUse ?? presetId}-${campaignId || 'new'}`}
    />
  );
};
